<template>
<!--eslint disable-->
  <div class="row no-gutters carrier-block" ref="edit_carrier_block">
    <div class="col-12 col-xl-4 mb-3 mb-xl-0 pl-0 pr-0 pr-xl-3">
      <fieldset class="border border-primary pt-2 pb-4 px-4 rounded">
        <legend  class="w-auto px-2 font-weight-bold smaller-font-content text-primary">Carrier Details</legend>
          <div class="text-right edit-links" ref="editLinks" style="display:block">
            <a href="JavaScript:void(0);" @click.prevent="toggleSave('edit')"><i class="fas fa-edit" title="Edit Agency"></i> Edit Details</a></div>
          <div class="row no-gutters edit-details">
            <div class = "col">
              <input-text :fieldData="carrierName" />

              <input-text :fieldData="carrierTag" />
              <div class="field-subtext pr-2 cartag">
                <div class="form-text smaller-font-content" v-html="carrierTag.sub_text"></div>
              </div>
              <div class="radio-field">
                <input-radio-button :fieldData="carrierStatus" />
              </div>
            </div>
          </div>
          <div class="text-right mt-3 details-button" style="display:none" ref="detailsbtn">
            <button type="button" class="btn btn-outline-secondary" id="add-user-cancel" tabindex="1"  @click="toggleSave('cancel')">Cancel</button>
            <button type="button" class="btn btn-success ml-3" tabindex="1" @click="saveCarrierInfo('details')">Save</button>
        </div>
      </fieldset>
    </div>
    <div class="col-12 col-xl-8 pl-0 pr-0">
      <fieldset class="border border-primary px-4 py-3 rounded" v-if="this.$store.getters.getAddStatus">
        <legend  class="w-auto px-2 font-weight-bold smaller-font-content text-primary">Carrier Integration Set up</legend>
        <div class="row no-gutters" ref="new_integration">
          <div class = "col-5">
              <input-product-type :insuranceType="insuranceType"></input-product-type>
              <!-- <filter-products :fieldData="chartProductFilters" :widgetType="'radio'" :widgetStyle="'colorful'" class="d-inline-block mb-1"></filter-products> -->
              <input-select :fieldData="integrationType" />
              <input-select :fieldData="ratecallType"  v-if="showRateCallBox"/>
              <input-text :fieldData="defaultCarrierId" v-if="showDefautlIDBox"/>
              <div class="radio-field">
               <input-radio-button :fieldData="programStatus" />
              </div>
            </div>
            <div class="col-7 pl-4">
              <span v-if="errorMsg" class="invalid-feedback d-block">Select atleast one state.</span>
              <span class="state-heading">State(s)</span>
              <div class="row no-gutters">
                <template v-for="(car, ckey) in carrierState.values">
                  <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4" :key="ckey">
                    <div class="field-input-checkbox form-group">
                      <div class="custom-control custom-checkbox smaller-font-content">
                        <input type="checkbox"
                          :id="car.stateName"
                          :ref="car.stateName"
                          :name="car.stateName"
                          :value="car.stateCd"
                          v-model="checked"
                          @change="check(car.stateCd)"
                          class="custom-control-input">
                        <label :for="car.stateName" class="custom-control-label"> {{car.stateName}} ({{car.stateCd}})</label>
                        <input
                          v-if="showDefautlIDBox"
                          type="text"
                          disabled
                          :name="`${car.stateCd}_ext`"
                          :id="`${car.stateCd}_ext`"
                          :ref="`${car.stateCd}_ext`"
                          :aria-describedby="`${car.stateName}_describedby`"
                          v-bind:class="{ 'edit-st form-control': true}">
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
        </div>
        <div class="row no-gutters justify-content-end">
          <div class="col-12 text-right">
            <button type="button" class="btn btn-outline-secondary" id="edit-agency-cancel" tabindex="1" @click="toggleSave('cancelAddInt')">Cancel</button>
            <button type="button" class="btn btn-success ml-3" tabindex="1" @click="saveInt">Save Integration</button>
          </div>
        </div>
      </fieldset>
      <template v-for="(product, pkey) in allproducts">
          <div class="row no-gutters edit-integration" :key="pkey+'_pro'">
            <!-- <integration-platform v-for="(integrationPlatform, key) in integrationPlatforms" :key="key" :integrationPlatform="integrationPlatform" :productId="productId" :productName="product.productName"></integration-platform> -->
            <template v-for="(integrationPlatform) in product.integrationPlatforms">
              <fieldset class="w-100 border border-primary pt-2 px-4 pb-3 rounded" :key="integrationPlatform.integrationId" :ref="'edit_int_details' + product.productId + '_' + integrationPlatform.integrationId" style="display:none">
                <legend  class="w-auto px-2 font-weight-bold smaller-font-content text-primary">Integration</legend>
              <div class="col-12 px-0">
                <div class="row">
                  <div class="col-4">
                    <img :src="integrationPlatform.integrationLogoURL" :alt="integrationPlatform.integrationName" class="edit-platform-logo mb-2" /><br/>
                    <span class="productName" :class="`product-icon-${product.productName}`">{{product.productName}}</span>
                    <b-form-group id="def_section" label-for="def_ext_id" class="mt-3" v-if="integrationPlatform.integrationId==1">
                      <div>
                        <label>Default External Carrier ID<span class='star'>*</span></label>
                      </div>
                      <b-form-input id="def_ext_id" name="def_ext_id" v-model="integrationPlatform.defaultExternalCarrierId" v-validate="{ required: true}" disabled></b-form-input>
                      <b-form-invalid-feedback :force-show="true" v-show="errors.has('def_ext_id')">
                        {{ errors.first('def_ext_id') }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <div class="form-group mt-2 radio-field">
                      <div><label>Integration Status<span class="required-red">*</span></label></div>
                      <div class="input-group field-input-radio">
                        <div data-toggle="buttons" class="btn-group btn-group-toggle">
                          <div class="btn btn-outline-light" :class="{'active': JSON.parse(integrationPlatform.integrationStatus)}">
                            <input
                              :name="'instatus_' + product.productId + '_' + integrationPlatform.integrationId"
                              v-model="integrationPlatform.integrationStatus"
                              :id="'instatus_true_' + product.productId + '_' + integrationPlatform.integrationId"
                              type="radio"
                              value="true">
                            <label class="cursorBox" :for="'instatus_true_' + product.productId + '_' + integrationPlatform.integrationId">ACTIVE</label>
                          </div>
                          <div class="btn btn-outline-light" :class="{'active': !JSON.parse(integrationPlatform.integrationStatus)}">
                            <input
                              :name="'instatus_' + product.productId + '_' + integrationPlatform.integrationId"
                              v-model="integrationPlatform.integrationStatus"
                              :id="'instatus_false_' + product.productId + '_' + integrationPlatform.integrationId"
                              type="radio"
                              value="false">
                            <label class="cursorBox" :for="'instatus_false_' + product.productId + '_' + integrationPlatform.integrationId">INACTIVE</label>
                          </div>
                        </div>
                        </div>
                    </div>
                  </div>
                  <div class="col-8">
                    <span class="state-heading">State(s)</span>
                    <div class="row no-gutters">
                      <!-- <template v-for="(states, mkey) in integrationPlatform.integrationAppointedStates">
                        <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4" :key="mkey">{{states}} -->
                          <carrier-platform-state v-for="(platformState, key) in integrationPlatform.integrationAppointedStates" :key="key" :platformState="platformState" :integrationId="integrationPlatform.integrationId" :productId="product.productId" :integrationPlatform="integrationPlatform"></carrier-platform-state>
                          <!-- <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike"> -->
                          <!-- <label for="vehicle1">{{states.stateName}}{{states.externalCarrierId}}</label><br> -->
                        <!-- </div>
                      </template> -->
                      <div class="col-12 text-right mt-3">
                        <button type="button" class="btn btn-outline-secondary" id="edit-agency-cancel" tabindex="1" @click.prevent="toggleEditInt('cancel', product.productId, integrationPlatform.integrationId)">Cancel</button>
                        <button type="button" class="btn btn-success ml-3" tabindex="1" @click="saveCarrierInfo('editint')">Save Integration</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </fieldset>
            </template>
          </div>
      </template>
      <template v-for="(product, pkey) in allproducts">
          <div class="row no-gutters" :key="pkey">
            <!-- <integration-platform v-for="(integrationPlatform, key) in integrationPlatforms" :key="key" :integrationPlatform="integrationPlatform" :productId="productId" :productName="product.productName"></integration-platform> -->
            <template v-for="(integrationPlatform, ikey) in product.integrationPlatforms">
              <fieldset class="w-100 border border-primary pt-2 px-4 pb-3 rounded" :key="ikey" :ref="'int_details' + product.productId + '_' + integrationPlatform.integrationId" style="display:block">
                <legend  class="w-auto px-2 font-weight-bold smaller-font-content text-primary">Integration</legend>
              <div class="col-12 px-0">
                <div class="row">
                  <div class="col-md-3">
                    <img :src="integrationPlatform.integrationLogoURL" :alt="integrationPlatform.integrationName" class="platform-logo" />
                    <br/><span class="productName" :class="`product-icon-${product.productName}`">{{product.productName}}</span>
                    <div class="form-group">
                      <div><label>Integration Status<span class="required-red">*</span></label></div>
                      <div class="input-group field-input-radio">
                        <div data-toggle="buttons" class="btn-group btn-group-toggle locked">
                          <div class="btn btn-outline-light" :class="{'active': JSON.parse(integrationPlatform.integrationStatus)}">
                            <input
                              :name="'instatuss_' + product.productId + '_' + integrationPlatform.integrationId"
                              :id="'instatuss_true_' + product.productId + '_' + integrationPlatform.integrationId"
                              type="radio"
                              value="true"
                              disabled>
                            <label class="cursorBox" :for="'instatuss_true_' + product.productId + '_' + integrationPlatform.integrationId">ACTIVE</label>
                          </div>
                          <div class="btn btn-outline-light" :class="{'active': !JSON.parse(integrationPlatform.integrationStatus)}">
                            <input
                              :name="'instatuss_' + product.productId + '_' + integrationPlatform.integrationId"
                              :id="'instatuss_false_' + product.productId + '_' + integrationPlatform.integrationId"
                              type="radio"
                              value="false"
                              disabled>
                            <label class="cursorBox" :for="'instatuss_false_' + product.productId + '_' + integrationPlatform.integrationId">INACTIVE</label>
                          </div>
                        </div>
                        </div>
                    </div>
                  </div>
                  <div class="col-md-9">
                    <!-- <fieldset class="border border-primary p-2 rounded">
                      <legend  class="w-auto px-2 font-weight-bold smaller-font-content text-primary">Appointed States</legend> -->
                      <div class="row no-gutters">
                        <div class="col-9 def-text">
                          <div class="">Default External Carrier ID</div>
                          <div class="my-2 font-weight-normal">{{integrationPlatform.defaultExternalCarrierId}}</div>
                        </div>
                        <div class="col text-right edit-links"><a href="JavaScript:void(0);" @click.prevent="toggleEditInt('edit', product.productId, integrationPlatform.integrationId)"><i class="fas fa-edit" title="Edit Agency"></i> Edit Integration</a></div>
                      </div>
                      <div class="row no-gutters">
                        <div class="col-12 state-heading mb-1">State(s)</div>
                        <!-- <span class="state-label">New Hampshir</span>
                        <span class="state-label">South Carolina</span>
                        <span class="state-label">District of Coulbia</span>
                        <span class="state-label">West Virginia</span> -->
                        <div v-if="integratedStatess(integrationPlatform.integrationAppointedStates)">
                          <template v-for="(platformState, key) in integratedStatess(integrationPlatform.integrationAppointedStates)">
                            <span class="state-label" :key="key">{{platformState.stateName}} ({{platformState.stateCd}})</span>
                          </template>
                          <span  class="state-label" v-if="showmore(integrationPlatform.integrationAppointedStates)">...</span>
                        </div>
                        <div v-else>NA</div>
                        <!-- <carrier-platform-state v-for="(platformState, key) in integratedStates" :key="key" :platformState="platformState" :integrationId="integrationId" :productId="productId" :integrationPlatform="integrationPlatform" class="col-12 col-sm-6 col-md-4 col-lg-2 col-xl-2"></carrier-platform-state> -->
                      </div>
                    <!-- </fieldset> -->
                  </div>
                </div>
              </div>
              </fieldset>
            </template>
          </div>
      </template>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import fetchData from '../../../../services/fetchData';
import postData from '../../../../services/postData';
import FilterProducts from '../../../interactive/widgets/FilterProducts';
import filters from '../../../../../config/admin/filters';
import ProductFilter from '../../../../services/ProductFilter';
import axios from '../../../../axios-config';
import CarrierPlatformState from './CarrierPlatformState';
import InputText from '../../../admin/interactive/InputText';
import InputSelect from '../../../admin/interactive/InputSelect';
import InputProductType from '../../../admin/interactive/InputProductType';
import InputCheckbox from '../../../admin/interactive/InputCheckbox';
import InputRadioButton from '../../../admin/interactive/InputRadioButton';
import User from '@/services/User';
import QRP from '../../../../../config/QRP.env';

export default {
  components: {
    FilterProducts,
    CarrierPlatformState,
    InputText,
    InputSelect,
    InputProductType,
    InputRadioButton
  },
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  data() {
    return {
      checked: [],
      checkedtext:[],
      errorMsg: false,
      carrierProductFilters: [],
      integratedArr : [],
      totalint : 0,
      carrierInfo: {},
      productAccess: [],
      carrierName: {
        field_name: 'user_firstName',
        field_value: '',
        rules: {
          required: true,
          regex: /^[a-zA-Z0-9 ]+$/,
        },
        field_type: 'text',
        values: [],
        placeholder: '',
        label: 'Carrier Name',
        is_enabled: false,
      },
      carrierTag: {
        field_name: 'user_middleInitial',
        field_value: '',
        rules: {
          required: true,
          alpha: true,
          max: 4,
        },
        field_type: 'text',
        values: [],
        placeholder: '',
        label: 'Carrier Tag',
        is_enabled: false,
        sub_text: '4 character abbreviation of the carriers name'
      },
      carrierStatus: {
        field_type: 'radio',
        field_name: 'carrierStatus',
        label: 'Carrier Status',
        field_value: '',
        rules: {
          required: true,
        },
        is_enabled: false,
        has_error: false,
        visible: true,
        values: [{ 
          visible: true,
          internal_value: 1,
          display_value: 'ACTIVE',
          },
          { 
          visible: true,
          internal_value: 0,
          display_value: 'INACTIVE',
          }],
      },
      programStatus: {
        field_type: 'radio',
        field_name: 'programStatus',
        label: 'Integration Status',
        field_value: 1,
        rules: {
          required: true,
        },
        is_enabled: true,
        has_error: false,
        visible: true,
        values: [{ 
          visible: true,
          internal_value: 1,
          display_value: 'ACTIVE',
          },
          { 
          visible: true,
          internal_value: 0,
          display_value: 'INACTIVE',
          }],
      },
      insuranceType: {
        field_name: 'insurance_type',
        label: 'Insurance Product',
        field_value: '',
        rules: [],
        field_type: 'text',
        help_text: '',
        values: [],
        is_required: true,
        is_enabled: true,
        visible: true,
        placeholder: null,
        sub_text: 'Select one product at a time',
        multi_select: false,
      },
      integrationType: {
        field_name: 'integrationType',
        field_value: '',
        rules: {
          required: true,
        },
        field_type: 'select',
        values: [],
        placeholder: 'Select One',
        label: 'Integration Type',
        is_enabled: true,
      },
      
      defaultCarrierId: {
        field_name: 'defaultCarrierId',
        field_value: '',
        rules: {
          required: true,
          numeric: true,
          max: 4,
        },
        field_type: 'text',
        values: [],
        placeholder: '',
        label: 'Default Carrier Id',
        is_enabled: true,
      },
      temparr:{
        values: [],
      },
      ratecallType: {
        field_name: 'ratecallType',
        field_value: '',
        rules: {
          required: true,
        },
        field_type: 'select',
        values: [{ 
          visible: true,
          value: 'rate1',
          label: 'Rate Call 1',
          },
          // { 
          // visible: true,
          // value: 'rate2',
          // label: 'Rate Call 2',
          // },
          { 
          visible: true,
          value: 'BindCall',
          label: 'BindCall',
          }],
        placeholder: 'Select One',
        label: 'Rate Call',
        is_enabled: true,
      },
      carrierState: {
        field_name: 'state',
        field_value: '',
        rules: {
          required: true,
        },
        field_type: 'multicheckbox',
        values: [],
        placeholder: null,
        label: 'Pilot State',
        is_enabled: true,
      },
    };
  },
  computed: {
    showDefautlIDBox() {
      return (this.integrationType.field_value=='1' ? true : false);
    },
    showRateCallBox() {
      return (this.integrationType.field_value=='0' ? true : false);
    },
    allproducts(){
      return this.carrierInfo.products;
    },
    integratedStates() {
      const stateList = this.integrationPlatforms.integrationAppointedStates.filter(states => states.isActive == true);//this.carrierIntegration.integrationAppointedStates;
      return stateList.slice(0, 4);  
    },
  },
  methods: {
    check(statecode){
      if(this.integrationType.field_value==1){
        var textcontrol = document.getElementById(statecode+'_ext');
        if(this.checked.includes(statecode)){
          textcontrol.removeAttribute("disabled");
          textcontrol.value = document.getElementById('defaultCarrierId').value;
        } else {
          textcontrol.setAttribute("disabled",true);
          textcontrol.value = '';
        }
      }
    },
    integratedStatess(state){
      const stateActive = state.filter(states => states.isActive == true);//this.carrierIntegration.integrationAppointedStates;
      //console.log('aaaaaaaaaaaa',stateActive, stateActive.slice(0, 4));
      if(stateActive.length){
        return stateActive.slice(0, 4); 
      } else {
        return false;
      }
    },
    showmore(state){
      const stateActive = state.filter(states => states.isActive == true);//this.carrierIntegration.integrationAppointedStates;
      return stateActive.length >4 ? true : false;
    },
    toggleDisplay(elemId, className) {
      if (document.getElementById(elemId).checked) {
        document.getElementsByClassName(className)[0].style.display = "block"
      } else {
        document.getElementsByClassName(className)[0].style.display = "none"
      }
    },
    async saveInt() {
      this.$validator.detach(this.insuranceType.field_name);
      this.$validator.attach({
        name: this.insuranceType.field_name,
        rules: 'required',
        getter: () => this.insuranceType.field_value,
      });
      const isValid = await this.$validator.validateAll();
      if(!isValid) {
        this.$refs.new_integration.scrollIntoView({ behavior: 'smooth' });
        if (this.errors.has('insurance_type')) { 
          var btnClass = document.getElementsByClassName('first_product-rad');         
          btnClass[0].focus();
        }
        return false;
      }
      if(this.checked.length == 0){
        this.$refs.new_integration.scrollIntoView({ behavior: 'smooth' });
        this.errorMsg = true;
        return false;
      } 
      let inststates = [];
      for(var i=0; i<this.checked.length;i++){
        inststates.push({'stateCd' : this.checked[i], 'externalCarrierId' : this.integrationType.field_value==1 ? document.getElementById(this.checked[i]+'_ext').value : ""});
      }
      const requestParams = {
          url: '/carriers/create',
          data: 
          {
            "comparativeRaterId": this.integrationType.field_value,
            "carrierId": `${this.$route.query.id}`,
            'carrierName': this.carrierName.field_value,
            'carrierTag':this.carrierTag.field_value,
            'carrierStatus':this.carrierStatus.field_value,
            "insuranceProduct": this.insuranceType.field_value,
            "rateCallType": this.integrationType.field_value == 1 ? 'rate1' : this.ratecallType.field_value,
            "defaultCarrierId": this.integrationType.field_value == 1 ? this.defaultCarrierId.field_value : '',
            "IntegrationAppointedStates": inststates,
            "programStatus":this.programStatus.field_value
        }
      }
      postData.postRuleDashboard(requestParams).then((response) => {
        let timeStamp = new Date().getTime();
        this.$router.push({ path: 'edit-carrier?' + timeStamp, query: { id: response.data.CarrierId }});
      }).catch((error) => {
        const errorMessage = (error.response && error.response && error.response.data ? error.response.data.Message : 'Unknown error.'); // TODO: Use config value

        this.$store.commit('updateAlerts', {
          messages: [
            `${errorMessage}`,
          ],
          variant: 'danger',
        });
      });
    },
    async saveCarrier() {
      window.console.info('Saving data...', this.carrierInfo);
      axios.post('carrierstateintegrations',
        this.carrierInfo, // TODO: Only send current product
      ).then(() => {
        this.$store.commit('updateAlerts', {
          messages: [
            'Success: Your edits have been saved.'
          ],
          variant: 'success',
        });

        this.requestCarrierStateIntegrationData();
      }).catch((error) => {
        const errorMessage = (error.response && error.response && error.response.data ? error.response.data.Message : 'Unknown error.'); // TODO: Use config value

        this.$store.commit('updateAlerts', {
          messages: [
            `${errorMessage}`,
          ],
          variant: 'danger',
        });

        window.console.warn('An error occurred while saving carrier.', error);
      });
    },
    async saveCarrierInfo(type) {
      if(type == 'details'){
        const isValid = await this.$validator.validateAll();
        if(!isValid) {
          this.activeTab1 = true;
          return false;
        }
        const requestParams = {
            url: '/carriers/updateCarrier',
            data: {
              "carrierId": `${this.$route.query.id}`,
              'carrierName': this.carrierName.field_value,
              'carrierTag':this.carrierTag.field_value,
              'carrierStatus':this.carrierStatus.field_value
            }
          }
        //console.log( requestParams.data);
        window.console.info('Saving data...', this.carrierInfo);
        postData.postRuleDashboard(requestParams).then((response) => {
          let timeStamp = new Date().getTime();
          this.$router.push({ path: 'edit-carrier?' + timeStamp, query: { id: `${this.$route.query.id}` }});
          //this.$store.dispatch('setUpdateSuccessMsg', true);
        }).catch((error) => {
          const errorMessage = (error.response && error.response && error.response.data ? error.response.data.Message : 'Unknown error.'); // TODO: Use config value

          this.$store.commit('updateAlerts', {
            messages: [
              `${errorMessage}`,
            ],
            variant: 'danger',
          });
        });
      } else if(type == 'editint'){
         axios.post('carrierstateintegrations',
            this.carrierInfo, // TODO: Only send current product
          ).then(() => {
            this.$store.dispatch('setUpdateSuccessMsg', true);
            let timeStamp = new Date().getTime();
            this.$router.push({ path: 'edit-carrier?' + timeStamp, query: { id: `${this.$route.query.id}` }});
          }).catch((error) => {
            const errorMessage = (error.response && error.response && error.response.data ? error.response.data.Message : 'Unknown error.'); // TODO: Use config value

            this.$store.commit('updateAlerts', {
              messages: [
                `${errorMessage}`,
              ],
              variant: 'danger',
            });
        });
      }
    },
    /**
     * Modifies API's carrier object to include needed properties that do not yet exist on the object. These
     * are only their initial values and are updated upon user interaction.
     *
     * isActive: An active geo state has its checkbox checked and disabled. Active states cannot become inactive (cannot be unchecked).
     * isCheckboxEnabled: Checkbox is disabled when the initial API response of that state is active (checked)
     * isTextEnabled: Text element is disabled when the initial API response of that state is inactive (unchecked)
     */
    modifyCarrierResponse(carrierResponse) {
      /* eslint no-param-reassign: "error" */
      let i = 0;
      carrierResponse.products.forEach((product) => {
        product.integrationPlatforms.forEach((integrationPlatform) => {
          if((integrationPlatform.integrationId == 0 || integrationPlatform.integrationId==1) && this.productAccess.includes(product.productId)){
            this.totalint = i + 1;
            i++;
          }
          if (!this.integratedArr[product.productId]) {
            this.integratedArr[product.productId] = [];
          } 
          this.integratedArr[product.productId].push(integrationPlatform.integrationId);
          integrationPlatform.integrationAppointedStates.forEach((integrationAppointedState) => {
            integrationAppointedState.isCheckboxEnabled = true;
            integrationAppointedState.isTextEnabled =  !!integrationAppointedState.isActive;
          });
        });
      });

      return carrierResponse;
    },
    requestCarrierStateIntegrationData() {
      window.console.info('Requesting carrier data...');

      axios.get(`carrierstateintegrations/${this.$route.query.id}`)
        .then((response) => {
          const carrierInfoResponse = response.data;
          this.carrierInfo = this.modifyCarrierResponse(carrierInfoResponse); 
          //let this.productAccess = JSON.parse(sessionStorage.getItem('productAccess')); 
          //total products added as ezlynx/direct less than total number of products * integration types (for now ezlynx n direct)
          // disable add new integration button
          console.log('this.totalint',this.totalint);
          if(this.totalint <  (2 * this.productAccess.length)){
            this.$store.commit('setDisabledStatus', false);
          } else {
            this.$store.commit('setDisabledStatus', true); 
          }

          this.$store.commit('updateCarrier', this.carrierInfo); // Allows parent components to reference the carrier's data

          // this.setProductFilters(this.carrierInfo);
          this.carrierName.field_value = this.$store.getters.carrier.carrierName;
          this.carrierTag.field_value = this.$store.getters.carrier.carrierCode;
          this.carrierStatus.field_value = this.$store.getters.carrier.isInActive == false ? 1 : 0;//this.$store.getters.carrier.carrierCode;

        }).catch((error) => {
          window.console.warn('An error occurred while requesting this carrier.', error);
        });
    },
    toggleSave(type){
      const detailsbtnDiv = this.$refs.detailsbtn;
      const detailsbtnContentDiv = this.$refs.editLinks;
      if(type == 'edit'){
        if((this.$store.getters.getAddStatus && this.$store.getters.getAddStatus) || (this.$store.getters.getEditStatus && this.$store.getters.getEditStatus)){
          return false;
        }      
        this.$store.commit('setEditStatus', true);
        this.carrierName.is_enabled = true;
        this.carrierTag.is_enabled = true;
        this.carrierStatus.is_enabled = true;
        detailsbtnDiv.style.display = 'block';
        detailsbtnContentDiv.style.display = 'none';
      } else if(type == 'cancel') {
        this.$store.commit('setEditStatus', false);
        this.carrierName.is_enabled = false;
        this.carrierTag.is_enabled = false;
        this.carrierStatus.is_enabled = false;
        detailsbtnDiv.style.display = 'none';
        detailsbtnContentDiv.style.display = 'block';
      } else {
        this.$store.commit('setAddStatus', false);
      }
      this.$refs.edit_carrier_block.scrollIntoView({ behavior: 'smooth' });
    },
    toggleEditInt(type,productId,integrationId){
      const detailsbtnDiv = this.$refs['int_details' + productId + '_' + integrationId];
      const detailsbtnContentDiv = this.$refs['edit_int_details' + productId + '_' + integrationId];
      if(type == 'edit'){
        if((this.$store.getters.getAddStatus && this.$store.getters.getAddStatus) || (this.$store.getters.getEditStatus && this.$store.getters.getEditStatus)){
          return false;
        }      
        this.$store.commit('setEditStatus', true);
        detailsbtnDiv[0].style.display = 'none';
        detailsbtnContentDiv[0].style.display = 'block';
      } else {
        this.$store.commit('setEditStatus', false);
        detailsbtnDiv[0].style.display = 'block';
        detailsbtnContentDiv[0].style.display = 'none';
      }
      this.$refs.edit_carrier_block.scrollIntoView({ behavior: 'smooth' });
    }
  },
  mounted() {
     fetchData.getDashboard('carriers/create').then((response) => {
      if(response.data) {
        if (response.data.IntegrationType) {
          for (let aCnt = 0; aCnt < response.data.IntegrationType.length; aCnt += 1) {
            if(response.data.IntegrationType[aCnt].integrationId == 0 || response.data.IntegrationType[aCnt].integrationId == 1){
              this.integrationType.values.push({visible: false, value: response.data.IntegrationType[aCnt].integrationId, label: response.data.IntegrationType[aCnt].integrationName });
              this.temparr.values.push({visible: false, value: response.data.IntegrationType[aCnt].integrationId, label: response.data.IntegrationType[aCnt].integrationName })
            }
          }
        }
        if (response.data.States) {
          for (let aCnt = 0; aCnt < response.data.States.length; aCnt += 1) {
            this.carrierState.values.push({stateCd: response.data.States[aCnt].stateCode, stateName: response.data.States[aCnt].stateName, externalCarrierId: "", isActive: false })
          }
        }
      }
    }).catch((error) => {
      console.log('error', error);
    });
    this.productAccess = JSON.parse(sessionStorage.getItem('productAccess'));
    this.productButtonsData = Object.create(this.insuranceType);
    const productOrder = [1, 21, 18, 12];
    if (typeof this.productAccess === 'object') {
      for (let i = 0; i < productOrder.length; i += 1) {
        if (this.productAccess.includes(productOrder[i])) {
          this.productButtonsData.values.push(filters.search_products_with_icons[productOrder[i]]);
        }
      }
    } else {
      const productAccessArray = this.productAccess.split(',');

      for (let i = 0; i < productOrder.length; i += 1) {
        if (productAccessArray.includes(productOrder[i])) {
          this.productButtonsData.values.push(filters.search_products_with_icons[productOrder[i]]);
        }
      }
    }

    // if (this.productAccess.length === 1) {
    //   this.productButtonsData.field_value = this.productAccess[0]; // the single product is set as the selected one
    // }

    this.insuranceType = [];
    this.insuranceType = this.productButtonsData;    
    this.requestCarrierStateIntegrationData();
  },
  watch: {
    // Updates parent property since no two-way binding in Vue and the parent object can't be passed to the InputCheckbox component.
    'insuranceType.field_value': function fieldDataCheckboxFieldValue(newValue) {
      this.integrationType.field_value = '';
      this.defaultCarrierId.field_value = '';
      this.ratecallType.field_value = '';
      this.checked =[];
      // console.log(this.insuranceType.field_value,this.integratedArr,this.integratedArr[newValue],this.integrationType.values);
      if(this.integratedArr[newValue]){
          this.integratedArr['values'] = [];
          for(let iCnt = 0; iCnt < this.temparr.values.length; iCnt += 1){           
            if(this.integratedArr[newValue].includes(this.temparr.values[iCnt].value)){                
                // console.log('this.integrationType.values[iCnt]',iCnt,this.temparr.values[iCnt].value);
              }  else {
                this.integratedArr.values.push(this.temparr.values[iCnt]);
              } 
          }
          this.integrationType.values = this.integratedArr.values;
      } else {
        this.integrationType.values = this.temparr.values;
      }
    },
    'checked': function fieldDataCheckboxFieldValue(newValue) {
      if(this.checked.length >0 ){
        this.errorMsg = false;
      } 
    }
  }
};
</script>

<style>
.carrier-block .locked .cursorBox{
  pointer-events: none;
}
.carrier-block .field-subtext{
  color:#595959;
}
.carrier-block .cartag{
  margin-top:-10px;
}
.carrier-block .instype{
  margin-top:-5px;
}
.carrier-block .edit-details .input-group, .full-width-div .btn-group{
  width: 100% !important;
}
.carrier-block .edit-links a{
  color:#003366;
  font-size:12px;
}
.carrier-block .btn-outline-secondary{
  color: #00234F !important;
  border-color: #00234F !important;
}
.carrier-block .btn-success{
  background-color: #00234F !important;
  border-color: #00234F !important;
}
.carrier-block .btn-success:hover{
  background-color: #ffffff !important;
  border-color: #00234F !important;
  color:#00234F !important;
}
.carrier-block .btn-outline-secondary:hover {
    color: #ffffff !important;
    background-color: #00234F !important;
    border-color: #00234F !important;
}
.carrier-block img.platform-logo {
    width: 88px !important;
    height: auto !important;
    max-width: 100px;
    margin-bottom:10px;
}
.carrier-block img.edit-platform-logo {
    width: 88px !important;
    height: auto !important;
    max-width: 100px;
}
.carrier-block .productName{
  background-color:#DCDFE7;
  padding:4px 12px 4px 12px;
  border-radius:25px;
  /* border:1px solid #DCDFE7; */
  font-size:12px;
  color:#2D374C;
  font-weight:600;
  display: inline-block;
  margin-bottom:10px !important;
}
.carrier-block .def-text{
  font-size:12px;
  color:#333333;
  font-weight:500;
}
.carrier-block .state-label{
  border: 1px solid #CCCCCC;
  font-size: 12px;
  border-radius: 25px;
  padding: 4px 8px;
  margin: 0px 8px 0px 0px;
  color: #000000;
}
.carrier-block .edit-links{
  color:#003366;
  font-size:12px;
}
.carrier-block .state-heading{
   font-size: 12px;
   font-weight: 500;
   color:#333333;
}
/* .edit-integration .state-heading{
   font-weight: 500;
}  */
.carrier-block span.product-icon-Auto {
  background-color: #DCDFE7;
  color: #2D374C;
}
.carrier-block span.product-icon-Home {
  background-color: #DBE5E5;
  color: #314D4D;
}
.carrier-block span.product-icon-Condo {
  background-color: #E6E0E7;
  color: #423545;
}
.carrier-block span.product-icon-Renters {
  background-color: #ECE1CF;
  color: #603F0B;
}
.carrier-block .field-input-checkbox label{
  font-weight: 400;
  color : #000000;
}
#def_ext_id{
  width:6em !important;
}
.carrier-block .custom-control-input:checked ~ .custom-control-label::before{
  background-color: #333333 !important;
}
.edit-st.form-control{
  width:80% !important;
}
.carrier-block .btn-group.btn-group-toggle .btn {
  padding: 0.1875rem 1rem 0;
}

.carrier-block .btn-outline-light {
  color: #333333;
  background-color: transparent;
  background-image: none;
  border-color: #ced4da;
}
.carrier-block .radio-field .field-input-radio .input-group .btn-group > .btn-group-inner-div.btn.btn-outline-light:nth-last-child(3n) {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}
.carrier-block .btn-outline-light:not(:disabled):not(.disabled):active,
.carrier-block .btn-outline-light:not(:disabled):not(.disabled).active,
.carrier-block .show>.btn-outline-light.dropdown-toggle {
  color: #FFFFFF;
  background-color: #00162B;
  border-color: #00162B;
}   
.carrier-block .btn-group-toggle>.btn-group>.btn input[type=radio]{
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/carriers/stateIntegration/StateIntegration.vue?59f26b60